export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '3c034ec7-438b-4065-8b69-020c38b17474'
export const MODAL_CLOSE_SEC = 2.5;